import { FC } from 'react';
import { SponsorRequestButton } from '~/domain/sponsor/components/SponsorRequestButton/SponsorRequestButton';
import { Alert } from '~/application/components/Alert/Alert';
import { useSponsorRequestWidget, Props } from './useSponsorRequestWidget';
import styles from './SponsorRequestWidget.module.css';

export const SponsorRequestWidget: FC<Props> = (props) => {
  const { user, loginUser, canSponsorRequest, isSelf, onRequest } =
  useSponsorRequestWidget(props);

  return (
    <dl className={styles.root}>
      <dt className={styles.title}>スポンサー募集</dt>
      <dd>
        {isSelf && <Alert>自身へリクエストすることはできません。</Alert>}
        {!isSelf &&
        <>
            <p className={styles.summary}>
              スポンサーになって{user.name}さんを応援しよう！
              <br />
              メッセージを送ってスポンサーになろう。
            </p>
            {loginUser?.isMember &&
          <div className={styles.footer}>
                <SponsorRequestButton
              user={user}
              canSponsorRequest={canSponsorRequest}
              onRequest={onRequest} />

              </div>}

            {!loginUser &&
          <Alert theme="info">
                スポンサーになるにはログインが必要です。
              </Alert>}

            {loginUser && !loginUser.isMember &&
          <Alert theme="info">
                スポンサーになるには管理画面から団体作成が必要です。
              </Alert>}

          </>}

      </dd>
    </dl>);

};